import { KeyFacet, stringPart } from '../../models/KeyFacet';

export const uploadProgressKeyFacet = new KeyFacet<{
  sourceEntryKey: string;
}>('uploadProgress', {
  sourceEntryKey: stringPart()
});

export function getUploadProgressKey(sourceEntryKey: string): string {
  return uploadProgressKeyFacet.serialize({
    sourceEntryKey: sourceEntryKey
  });
}
